import React from "react";
import { ClientProps, RolePermission, UserProps } from "../interfaces/interfaces";

export interface SuperAdminTransactionRow {
  company: ClientProps;
  invoices: number;
  journalEntries: number;
  deposits: number;
  payments: number;
  creditMemos: number;
  totalActive: number;
}

export interface FlushPreview {
  company: ClientProps;
  counts: {
    invoices: number;
    journalEntries: number;
    deposits: number;
    payments: number;
    creditMemos: number;
  };
  total: number;
}

export interface SuperAdminUserPayload {
  name: string;
  username: string;
  role: RolePermission;
  clientIds: string[];
  active: boolean;
}

interface Props {
  companies: ClientProps[];
  users: UserProps[];
  transactionRows: SuperAdminTransactionRow[];
  flushPreview: FlushPreview | null;
  superAdminLoading: boolean;
  superAdminError: { status: boolean; message: string };
  superAdminSuccess: { status: boolean; message: string };
  getCompanies: () => void;
  getUsers: (filters?: { clientId?: string; search?: string }) => void;
  createUser: (data: SuperAdminUserPayload, next?: () => void) => void;
  updateUser: (
    idUser: string,
    data: SuperAdminUserPayload,
    next?: () => void,
  ) => void;
  removeUserFromCompany: (
    idUser: string,
    clientId: string,
    next?: () => void,
  ) => void;
  getTransactionCounts: () => void;
  getFlushPreview: (idClient: string) => void;
  flushCompany: (
    idClient: string,
    confirmCompanyName: string,
    next?: (deletedCounts: FlushPreview["counts"]) => void,
  ) => void;
  updateCompanySubscription: (
    idClient: string,
    active: boolean,
    next?: () => void,
  ) => void;
}

const SuperAdminContext = React.createContext<Props>({
  companies: [],
  users: [],
  transactionRows: [],
  flushPreview: null,
  superAdminLoading: false,
  superAdminError: { status: false, message: "" },
  superAdminSuccess: { status: false, message: "" },
  getCompanies: () => {},
  getUsers: () => {},
  createUser: () => {},
  updateUser: () => {},
  removeUserFromCompany: () => {},
  getTransactionCounts: () => {},
  getFlushPreview: () => {},
  flushCompany: () => {},
  updateCompanySubscription: () => {},
});

export default SuperAdminContext;
